import ActionTypes from '../constants/ActionTypes';

const deleteOrganizationMembership = (organizationId, userId) => ({
  type: ActionTypes.ORGANIZATION_MEMBERSHIP_DELETE,
  payload: {
    organizationId,
    userId,
  },
});

deleteOrganizationMembership.success = (organizationId, userId) => ({
  type: ActionTypes.ORGANIZATION_MEMBERSHIP_DELETE__SUCCESS,
  payload: {
    organizationId,
    userId,
  },
});

deleteOrganizationMembership.failure = (organizationId, userId, error) => ({
  type: ActionTypes.ORGANIZATION_MEMBERSHIP_DELETE__FAILURE,
  payload: {
    organizationId,
    userId,
    error,
  },
});

const handleOrganizationMembershipDelete = (organizationId, userId) => ({
  type: ActionTypes.ORGANIZATION_MEMBERSHIP_DELETE_HANDLE,
  payload: {
    organizationId,
    userId,
  },
});

export default {
  deleteOrganizationMembership,
  handleOrganizationMembershipDelete,
};
